module.exports = __webpack_public_path__ + "static/media/Dalton Cox Headshot.43839d95.jpeg";